import {MultiSwitchRequirement, StaticRequirement, SwitchRequirement, useFormContext} from '@yandex-delivery/form'
import {useMemo} from 'react'

import {SlotDivider} from 'src/shared/components/desktop'
import type {RequirementsMap} from 'src/shared/types'

import type {VerticalRequirementsProps} from './types'

export function VerticalRequirements(props: VerticalRequirementsProps) {
  const {onChange, showLastElementBorder} = props
  const {watch} = useFormContext()
  const selectedVerticalRequirements: RequirementsMap = watch('offerFlow.vertical.requirements')

  const requirementsArray = useMemo(() => {
    return selectedVerticalRequirements === undefined ? [] : Object.values(selectedVerticalRequirements)
  }, [selectedVerticalRequirements])

  return (
    <>
      {requirementsArray.map(requirement => {
        switch (requirement.type) {
          case 'bool':
            return (
              <SwitchRequirement
                key={requirement.name}
                name={`offerFlow.vertical.requirements.${requirement.name}.selectedValue` as const}
                onChange={onChange}
                requirement={{
                  type: 'switch',
                  name: requirement.name,
                  title: requirement.title,
                  defaultValue: requirement.default_value,
                }}
              />
            )
          case 'multi_select':
            return (
              <MultiSwitchRequirement
                key={requirement.name}
                name={`offerFlow.vertical.requirements.${requirement.name}.selectedValue` as const}
                onChange={onChange}
                requirement={{
                  type: 'multi_switch',
                  name: requirement.name,
                  title: requirement.title,
                  options: requirement.options.map(option => ({
                    name: option.title,
                    description: option.text,
                    value: option.value,
                  })),
                }}
              />
            )
          case 'included':
            return (
              <StaticRequirement
                key={requirement.name}
                requirement={{
                  type: 'static',
                  name: requirement.name,
                  title: requirement.title,
                  description: requirement.text,
                  value: requirement.selectedValue,
                }}
              />
            )
          default:
            return null
        }
      })}
      {showLastElementBorder && <SlotDivider />}
    </>
  )
}
